import { useState } from 'react';
import { noteEditionToSectionURL } from '../utils/ConstantsURL';
import { toastAlert } from '../utils/AlertContext';

export const useNoteEditionToSection = () => {
  const [isAdding, setIsAdding] = useState(false);

  const addNoteWithEditionToSection = async (
    id_documento,
    id_seccion,
    cvecapsula,
    titulo,
    sintesis,
    token,
    fecha_transferencia
  ) => {
    setIsAdding(true);

    try {
      if (!id_documento || !id_seccion) {
        throw new Error('id_documento e id_seccion son requeridos para transferir la nota');
      }

      const requestData = {
        id_documentoTarget: id_documento.toString(),
        id_seccionTarget: id_seccion.toString(),
        cvecapsula: cvecapsula.toString(),
        titulo: titulo,
        sintesis: sintesis,
        ...(fecha_transferencia && { fecha_transferencia }),
      };

      const response = await fetch(noteEditionToSectionURL(), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('🟦 useNoteEditionToSection: Error response:', errorData);
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      toastAlert(
        data.message || 'Nota agregada a la sección exitosamente con edición',
        'success'
      );

      return { success: true, data };
    } catch (error) {
      console.error('🟦 useNoteEditionToSection: Error:', error);
      
      toastAlert(
        error.message || 'Error al agregar la nota con edición a la sección',
        'error'
      );

      return { success: false, error: error.message };
    } finally {
      setIsAdding(false);
    }
  };

  return { addNoteWithEditionToSection, isAdding };
};

export default useNoteEditionToSection;
